<template>
  <b-modal
    :visible="isShow"
    @change="$emit('update:isShow', $event)"
    :id="id"
    content-class="modal-content-semi_round"
    centered
    :hide-footer="!footer"
    :hide-header="!header"
    :no-close-on-backdrop="noBackdrop"
    :no-close-on-esc="noEsc"
    :size="size"
  >
    <div class="text-center pt-3 modal-wrapper">
      <div class="close-btn" v-if="isShowCrossButton" @click="clickCrossButton">+</div>

      <b-img-lazy
        v-if="modalImage"
        :src="modalImage"
        class="image-modal"
      ></b-img-lazy>

      <slot name="modal-title">
        <h2 class="font-subtitle-2 modal-title" v-html="sanitizeXSS(modalTitle)"></h2>
      </slot>

      <p class="font-body-3 modal-text" v-html="sanitizeXSS(modalText)"></p>

      <s-button
        variant="primary"
        :size="isMobile ? 'medium' : 'small'"
        @onClick="submitModal()"
        class="w-100 mb-2"
        id="modal-submit-button"
      >{{submitButtonText}}</s-button>

      <s-button
        v-if="isHaveSecondaryBtn"
        variant="link"
        :size="isMobile ? 'medium' : 'small'"
        @onClick="closeModal()"
        class="w-100 mb-2 text-royal-navy-500"
        id="modal-close-button"
      >{{closeButtonText}}</s-button>
    </div>
  </b-modal>
</template>

<script>
import SButton from '@/components/atoms/buttons/SButton.vue'
import deviceDetector from 'mobile-device-detect'

export default {
  name: 'SModal',
  components: {
    SButton
  },
  data () {
    return {
      isMobile: deviceDetector.isMobile
    }
  },
  props: {
    isShow: Boolean,
    variant: {
      type: String,
      default: 'custom'
    },
    modalTitle: String,
    modalText: String,
    submitButtonText: {
      type: String,
      default: 'Ya'
    },
    closeButtonText: {
      type: String,
      default: 'Batal'
    },
    isHaveSecondaryBtn: {
      type: Boolean,
      default: false
    },
    isShowCrossButton: {
      type: Boolean,
      default: false
    },
    modalImage: String,
    size: {
      type: String,
      validator (value) {
        return ['sm', 'lg', 'xl'].includes(value)
      },
      default: 'sm'
    },
    id: {
      type: String,
      default: ''
    },
    footer: {
      type: Boolean,
      default: false
    },
    header: {
      type: Boolean,
      default: false
    },
    noBackdrop: {
      type: Boolean,
      default: true
    },
    noEsc: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    closeModal () {
      this.$emit('closeModal')
    },
    submitModal () {
      this.$emit('submitModal')
    },
    clickCrossButton () {
      this.$emit('clickCrossButton')
    },
    sanitizeXSS (htmlEmbed) {
      return this.$XSSFilter(htmlEmbed)
    }
  },
  computed: {
    imgSrc () {
      switch (this.variant) {
        case 'custom':
          return this.modalImage
      }
    }
  }
}
</script>

<style scoped>
.modal-wrapper {
  padding: 8px;
  padding-bottom: 0px;
}

.image-modal {
  width: 192px;
  height: 144px;
  object-fit: contain;
  margin-bottom: 10px;
}

.modal-title {
  color: var(--color-royal-navy-900);
  margin-bottom: 12px;
}

.modal-text {
  color: var(--color-ui-element-black);
  margin-bottom: 16px;
}

.close-btn{
  position: absolute;
  top: 6px;
  right: 25px;
  font-size: 26px;
  transform: rotate(45deg);
  color: var(--color-neutral-700);
  cursor: pointer;
}
</style>
